// extracted by mini-css-extract-plugin
export default {"why":"Why_why__dssgw","images":"Why_images__2sUh5","box":"Why_box__tqYSk","question":"Why_question__f6iry","answer":"Why_answer__l+ZpQ"};